import { Grid, makeStyles, Typography } from '@material-ui/core'
import { FC, useState, useEffect } from 'react'
import UploadImage from '../../../control/uploadImage/uploadImage'
import useTranslate from '../../../i18n/useTranslate'
import useWebService from '../../../services/web/useWebService'

import { LanguageType } from '../../../services/um/useAddUsergroup'
import { convertPathToNameImg } from '../../../utilities/pathImg'

interface UploadLogoProps {
    initialValue?: any
    form: any
}
const UploadLogo: FC<UploadLogoProps> = ({ initialValue, form }) => {
    const translate = useTranslate()
    const classes = usestyles()

    const callWebService = useWebService()
    const [temp, setTemp] = useState<{
        signatureTH: string | null
        signatureEN: string | null
        name_th: string | null
        name_en: string | null
    }>({
        signatureTH: null,
        signatureEN: null,
        name_th: null,
        name_en: null,
    })

    useEffect(() => {
        setTemp({
            signatureTH: initialValue?.signatureTH
                ? `${process.env.REACT_APP_UPLOAD}${initialValue?.signatureTH}`
                : null,
            signatureEN: initialValue?.signatureEN
                ? `${process.env.REACT_APP_UPLOAD}${initialValue?.signatureEN}`
                : null,
            name_th: convertPathToNameImg(initialValue?.signatureTH) || null,
            name_en: convertPathToNameImg(initialValue?.signatureEN) || null,
        })
    }, [])

    const onUpload = async (event: React.ChangeEvent<HTMLInputElement>, language: LanguageType) => {
        const file = event.target.files?.[0]
        const formDataImage = new FormData()
        if (file) {
            formDataImage.append('files', file)

            const { result } = await callWebService.uploadFileTemp(formDataImage)

            if (result.length > 0) {
                if (language === 'th') {
                    setTemp({ ...temp, signatureTH: result[0].path, name_th: result[0].filename })
                    form.change('signatureTH', result)
                } else {
                    setTemp({ ...temp, signatureEN: result[0].path, name_en: result[0].filename })
                    form.change('signatureEN', result)
                }
            }
        }
    }

    return (
        <Grid container justify="center" spacing={2} className={classes.container}>
            <Grid item xs={12} md={6} lg={6}>
                <Typography>{translate.get('UM.UPLOAD.SIGNATURE_TH')}</Typography>
                <img
                    src={temp.signatureTH ? `${temp.signatureTH}` : `${process.env.PUBLIC_URL}/img/default.jpg`}
                    id="profile"
                    alt=""
                    width="300"
                    height="230"
                    className={classes.image}
                />
                <Grid container alignItems="center" direction="row">
                    <Grid item xs={12} md={6} lg={6} style={{ textAlign: 'center', wordBreak: 'break-word' }}>
                        <Typography>{temp.name_th ? temp.name_th : ''}</Typography>
                    </Grid>
                    <Grid item xs={12} md={6} lg={6} style={{ textAlign: 'end' }}>
                        <UploadImage
                            name="signatureTH"
                            onChange={(event) => onUpload(event, 'th')}
                            color={'primary'}
                            labelTitle={translate.get('BUTTON.UPLOAD')}
                        />
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
                <Typography>{translate.get('UM.UPLOAD.SIGNATURE_EN')}</Typography>
                <img
                    src={temp.signatureEN ? `${temp.signatureEN}` : `${process.env.PUBLIC_URL}/img/default.jpg`}
                    id="profile"
                    alt=""
                    width="300"
                    height="230"
                    className={classes.image}
                />

                <Grid container alignItems="center" direction="row">
                    <Grid item xs={12} md={6} lg={6} style={{ textAlign: 'center', wordBreak: 'break-word' }}>
                        <Typography>{temp.name_en ? temp.name_en : ''}</Typography>
                    </Grid>
                    <Grid item xs={12} md={6} lg={6} style={{ textAlign: 'end' }}>
                        <UploadImage
                            name="signatureEN"
                            onChange={(event) => onUpload(event, 'en')}
                            color={'primary'}
                            labelTitle={translate.get('BUTTON.UPLOAD')}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}
export default UploadLogo

const usestyles = makeStyles((theme) => ({
    image: {
        display: 'flex',
        margin: '15px auto',
        objectFit: 'contain',
    },
    container: {
        padding: '8px 15px',
    },
}))
